<template lang="pug" src="./custom-home-survey.pug"></template>

<script>
import { onScroll } from 'resources/mixins'

export default {
  data () {
    return {
      containerActive: false,
      options: {
        root: null,
        rootMargin: '0px',
        threshold: [0.25]
      }
    }
  },
  props: ['props'],
  mixins: [onScroll],
  methods: {
    rowScroll ({el, going, direction}) {
      if (going === 'in' && direction === 'top') {
        el.classList.add('custom-home-survey--active')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/custom/custom-home-survey/custom-home-survey.vue